/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	GridInvoiceInfo: function (state) {
		if (state && state.GridInfo && state.GridInfo.GridInvoice) {
			return state.GridInfo.GridInvoice;
		}
	},
	GetReduce(state) {
		return state.reduce;
	},
	tourGuideRunning(state) {
		return state.tourGuideRunning;
	},
	GuideStartedStepV2(state) {
		return state.GuideStartedStepV2;
	},
	IsLoadingTotalAmountPage(state) {
		return state.isLoadingTotalAmountPage;
	},
	TakeItem(state) {
		return state.TakeItem;
	},
	IsLoadingPushData(state) {
		return state.isLoadingPushData;
	},
	getUpdateIdentificationPopupActive(state) {
		return state.updateIdentificationPopupActive
	}
};
